import React, { useState } from 'react';
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Box,
  Popover,
  Typography,
  InputBase,
  SelectChangeEvent,
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';

interface ColumnFilterComponentProps {
  selectedColumns: string[];
  handleColumnChange: (event: SelectChangeEvent<string[]>, child: React.ReactNode) => void;
  availableColumns: string[];
}

const ColumnFilterComponent: React.FC<ColumnFilterComponentProps> = ({
  selectedColumns,
  handleColumnChange,
  availableColumns,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [searchTerm, setSearchTerm] = useState<string>('');

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.name;
    const newSelectedColumns = event.target.checked
      ? [...selectedColumns, value]
      : selectedColumns.filter((column) => column !== value);
    handleColumnChange({ target: { value: newSelectedColumns } } as SelectChangeEvent<string[]>, null);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const filteredColumns = availableColumns.filter((column) => column.toLowerCase().includes(searchTerm.toLowerCase()));

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div style={{ marginLeft: '20px' }}>
      <Button
        sx={{
          backgroundColor: '#136033',
          color: 'white',
          '& .MuiButton-startIcon': {
            margin: 0,
          },
        }}
        aria-describedby={id}
        variant="outlined"
        onClick={handleOpen}
        startIcon={<FilterListIcon />}
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Box sx={{ p: 2, width: 300 }}>
          <Typography variant="h6">Escolha as colunas para pesquisar</Typography>
          <Box sx={{ my: 1 }}>
            <InputBase
              placeholder="Encontrar uma coluna"
              value={searchTerm}
              onChange={handleSearchChange}
              sx={{ width: '100%', px: 1, py: 0.5, border: '1px solid #ccc', borderRadius: '4px' }}
            />
          </Box>
          <FormControl component="fieldset">
            <FormGroup>
              {filteredColumns.map((column) => (
                <FormControlLabel
                  key={column}
                  control={
                    <Checkbox
                      checked={selectedColumns.indexOf(column) > -1}
                      onChange={handleCheckboxChange}
                      name={column}
                    />
                  }
                  label={column}
                />
              ))}
            </FormGroup>
          </FormControl>
        </Box>
      </Popover>
    </div>
  );
};

export default ColumnFilterComponent;
